(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("latte-carousel"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "latte-carousel"], factory);
	else if(typeof exports === 'object')
		exports["ReactLatte"] = factory(require("react"), require("latte-carousel"));
	else
		root["ReactLatte"] = factory(root["React"], root["latte"]);
})((typeof window !== "undefined" ? window : this), function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 